import {
    getReportConfigurationClients,
    getReportConfigurationDataModels,
    getReportConfigurationLookups,
    getReportConfigurationRuleOperators,
} from "../../../../service/httpsCalls";

export const loadClients = () => getReportConfigurationClients();

export const loadDataModels = () => getReportConfigurationDataModels();

export const loadRuleOperators = () => getReportConfigurationRuleOperators();

export const loadLookups = (clientId?: number) => getReportConfigurationLookups(clientId);
